import { StyleSheet } from 'aphrodite/no-important';

import {
  spacers,
  typography,
  palettes,
  fonts,
} from '../../node_modules/@trainline/depot-web/lib/css/themes/trainline';

export default StyleSheet.create({
  container: {
    marginBottom: spacers.dp_s24,
  },
  filtersResults: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bookingsCountText: {
    fontWeight: fonts.dp_font_weight_regular,
    fontSize: typography.dp_body_font_size,
    color: palettes.dp_app_text_subtle,
  },
  bookingsFilterText: {
    fontWeight: fonts.dp_font_weight_regular,
    fontSize: typography.dp_mini_font_size,
    color: palettes.dp_app_text_subtle,
  },
  showBookingsButton: {
    marginTop: spacers.dp_s12,
  },
  appliedFiltersContainer: {
    marginTop: spacers.dp_s16,
    marginBottom: spacers.dp_s24,
  },
  appliedFilter: {
    color: palettes.dp_app_text_subdued,
    marginRight: spacers.dp_s32,
    display: 'inline-flex',
    alignItems: 'center',
  },
  removeButton: {
    width: '24px',
    height: '24px',
    borderWidth: 0,
  },
  filterButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: spacers.dp_s16,
  },
  filterCheckBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacers.dp_s16,
  },
  icon: {
    marginLeft: spacers.dp_s4,
  },
  filterMenuButton: {
    ':nth-child(1n) > span': {
      maxWidth: '150px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
});
